<template>
	<div>
		<!-- header -->
		<Mynav></Mynav>
		<div class="wrapper">
			<!-- swiper -->
			<swiper class="swiper-box swiper-no-swiping" :options="swiperOption" ref="mySwiper"
				style="min-width:1200px">
				<!-- shapez -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/Shapezio-large.png')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Shapez.io</p>
							<p class="Swiper-detail">Game genre：（PC）Strategy, Building, Automation, Base Building<br>
								Release date: June, 2020<br>
								Platform: Steam & Wegame<br>
								Achievements:<br>
								- "23rd top rated steam game 2020" (according to PCGamer.com)<br>
								- "Oh crap. I really should sleep, but I think I just figured out how to make a computer
								in shapez.io"-Notch
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickShape">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- Aground -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/Aground-large.png')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Aground</p>
							<p class="Swiper-detail">Game genre：（PC）Exploration, Open World, Story Rich, Building,
								Rpg<br>
								Release date: Planned in Q1, 2022<br>
								Platform: Wegame
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickAground">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- CraftTheWorld -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/Crafttheworld-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">CraftTheWorld</p>
							<p class="Swiper-detail">Game genre：（PC）Sandbox, Craft, Build, Colony Sim<br>
								Release date: 2019.07<br>
								Platform: Wegame<br>
								Achievements:<br>
								- Platform-wide Promotion No. 2 in Summer 2019<br>
								- Has been the top seller of the week for many times.

							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickCrafttheworld">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- Tunnel of Doom -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/tod-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Tunnel of Doom</p>
							<p class="Swiper-detail">Game genre:（PC）Roguelike,Adventure,Strategy，Tower Defence<br>
								Release date: Q4, 2021<br>
								Platform: Steam
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClicktod">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- LAZR -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/lazr-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">LAZR - A Clothformer</p>
							<p class="Swiper-detail">Game genre: （PC）Cyberpunk, Action, Platform Game<br>
								Release date: Q3, 2021<br>
								Platform: Steam				
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickcraftlands">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- Tangledeep -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/tangledeep-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Tangledeep</p>
							<p class="Swiper-detail">Game genre：(PC)Mystery Dungeon,Dungeon Crawler,Turn-Based<br>
								Release date: Planned in Q4,2021<br>
								Platform: Steam & Wegame<br>
								Achievements:<br>
								- LISBON INDIE DOME 2017 - FINALIST
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClicktangledeep">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- Blood Rite -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/bloodrite-large.png')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Blood Rite</p>
							<p class="Swiper-detail">Game genre：（PC）3D MMORPG<br>
								Release date: Nov, 2010<br>
								Achievements:<br>
								- China Taiwan's top-earning 3D online game in 2011<br>
								- Russia's best-selling Chinese MMORPG in 2012<br>
								- Released in China,China Taiwan,Russia,South Korea,Southeast Asia
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickbloodrite">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- loong3d -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/loong-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">Loong 3D</p>
							<p class="Swiper-detail">Game genre: （PC）3D MMORPG<br>
								Release date: Oct, 2009<br>
								Achievements:<br>
								- Top 3 3D Online Games in China in 2009!<br>
								- Max DAU over 500,000. Max CCU over 180,000.<br>
								- Released in 36 countries and regions around the world
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickloong3d">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- KungFu Heroes -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/kungfuheroes-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">KungFu Heroes</p>
							<p class="Swiper-detail">Game genre：（PC）3D MMORPG<br>
								Release date: Mar, 2014<br>
								Achievements:<br>
								- China Taiwan's top-earning 3D online game in 2014<br>
								- Released in China,China Taiwan,South Korea,Southeast Asia
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClickkungfuheros">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>
				<!-- New Meteor and Sword -->
				<swiper-slide class="swiper-slide swiper-item">
					<div class="swiper-box-item"
						:style="'background-image: url('+require('../../assets/home/sword-large.jpg')+')'">
						<div class="Swiper-content">
							<p class="Swiper-title">New Meteor and Sword</p>
							<p class="Swiper-detail">Game genre: （PC）3D Fighting Action RPG<br>
								Release date: Oct, 2017<br>
								Achievements:<br>
								- The perfect combination of Chinese martial arts and 3D action combat, created a new
								game genre in China.<br>
								- Max MAU over 1000,000.
							</p>
						</div>
						<div class="Swiper-btn transition" @click="swiperClicknewmeteorandsword">
							<span>VIEW THE WEBSITE</span>
							<img src="../../assets/home/btnRight.png" />
						</div>
					</div>
				</swiper-slide>				
			</swiper>


			<!-- LATEST NEWS -->
			<div class="New-box">
				<div class="New-title">
					<p>GAMES</p>
				</div>
				<div class="New-content">
					<div class="New-items" v-for="(item,index) in NewListA" @click="NewclickA('',`${item.type}`)"
						:key="index">
						<div class="img-box">
							<img class="New-img transition" :src="item.img" />
						</div>
						<div class="New-items-contnet">
							{{item.detail}}
						</div>
						<!-- date -->
						<!-- <div class="New-date">12 Mar 2021</div> -->
					</div>
				</div>
				<!-- <div class="New-btn transition" @click="more">
                    <p>MORE</p>
                    <img src="../../assets/home/more02.png" />
                </div> -->
			</div>
			<!-- LATEST NEWS -->
			<div class="New-box">
				<!-- <div class="New-title"><p>GAMES</p></div> -->
				<div class="New-content">
					<div class="New-items" v-for="(item,index) in NewListB" @click="NewclickB('',`${item.type}`)"
						:key="index">
						<div class="img-box">
							<img class="New-img transition" :src="item.img" />
						</div>
						<div class="New-items-contnet">
							{{item.detail}}
						</div>
						<!-- date -->
						<!-- <div class="New-date">12 Mar 2021</div> -->
					</div>
				</div>
				<div class="New-btn transition" @click="more">
					<p>MORE</p>
					<img src="../../assets/home/more02.png" />
				</div>
			</div>
			<!-- CONTACT US -->
			<div class="Contact-box">
				<div class="New-title">
					<p>CONTACT US</p>
				</div>
				<div class="Contact-content">
					<div class="Contact-items transition" v-for="(item,index) in ContactList" :key="index">
						<div class="Contact-items-top">
							<p>{{item.title}}</p>
							<p>{{item.mail}}</p>
						</div>
						<!-- <div class="Contact-items-bottom">Leave Message</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="swiper-button-prev"></div>
		<div class="swiper-button-next"></div>
		<!-- <div class="swiper-pagination"></div> -->
		<!-- footer -->
		<Myfooter></Myfooter>
	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				ContactList: [{
						title: 'Contact BD Team',
						mail: 'jiangkan@gamejoygames.com'
					},
					{
						title: 'Contact Development Team',
						mail: 'wangleiqiang@gamejoygames.com'
					}
				],
				//A shapez crafttheworld aground
				NewListA: [{
						img: require('../../assets/new/shapezio-small.jpg'),
						detail: 'shapez.io is a game about building factories to automate the creation and processing of increasingly complex shapes across an infinitely expanding map.',
						type: 'shapez'
					},
					{
						img: require('../../assets/new/Crafttheworld-small.jpg'),
						detail: 'Craft The World is a unique sandbox strategy game, the mix of Dungeon Keeper, Terraria and Dwarf Fortress.Explore a random generated world populated by dangerous creatures, build a dwarf fortress, gather resources, and craft all the items, weapons, and armor you need.',
						type: 'crafttheworld'
					},
					{
						img: require('../../assets/new/Aground-small.jpg'),
						detail: 'As one of the last human survivors, you find yourself stranded on an uninhabited island. With a few other victims of the crash, can you craft, mine, and build your way to survival?',
						type: 'aground'
					},
				],
				//B tangledeep lazr tunnelofdoom
				NewListB: [{
						img: require('../../assets/new/tangledeep-small.jpg'),
						detail: 'Enter the magical world of Tangledeep, a beautifully polished dungeon crawler inspired by classic 16-bit RPGs! Colorful characters, a unique job system, tons of skills, items, and diverse environments with deep, turn-based roguelike gameplay. A different adventure every time you play!',
						type: 'tangledeep'
					},
					{
						img: require('../../assets/new/lazr-small.jpg'),
						detail: 'A new era of physics based platforming is about to begin. Play as fusion powered killer android Lazr, facing off against rogue AI and mega-corporations in Alpha City One.',
						type: 'lazr'
					},
					{
						img: require('../../assets/new/tod-small.jpg'),
						detail: 'Tunnel of Doom is an action rogue-lite hybrid that mixes tower defense with melee and ranged combat gameplay. Randomly generated, every run is different as you guide Angel on a quest to rescue her husband. Gather resources, discover perks, and use what you find to battle waves of monsters.',
						type: 'tod'
					},

				],
				bannerList: ['../../assets/home/Aground-large.png', '../../assets/home/Aground-large.png'],
				swiperOption: {
					loop: true, //是否循环轮播
					speed: 2000, //切换速度
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					//自动轮播
					autoplay: {
						delay: 6000,
						disableOnInteraction: false,
					},
					//设置slider容器能够同时显示的slides数量
					slidesPerView: 1,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
			}
		},
		created() {},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
		methods: {
			//A shapez crafttheworld aground
			//B tangledeep craftlands dangerscavenger
			NewclickA(index, type) {
				if (type == 'aground') {
					//该路由在router---index.js里已配置
					window.open('https://store.steampowered.com/app/876650/Aground/')
				} else if (type == 'crafttheworld') {
					window.open('https://www.wegame.com.cn/store/2000348/Craft_the_World')
				} else if (type == 'shapez') {
					window.open('https://store.steampowered.com/app/1318690/shapezio/')
				}
			},
			NewclickB(index, type) {
				if (type == 'tangledeep') {
					//该路由在router---index.js里已配置
					window.open('https://store.steampowered.com/app/628770/Tangledeep/')
				} else if (type == 'lazr') {
					window.open(
						'https://store.steampowered.com/app/1181040/LAZR__A_Clothformer/'
					)
				} else if (type == 'tod') {
					window.open('https://store.steampowered.com/app/1361840/Tunnel_of_Doom/')
				}
			},
			more() {
				this.$router.push({
					path: '/games'
				})
			},
			swiperClickAground() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://store.steampowered.com/app/876650/Aground/')
			},
			swiperClickShape() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://store.steampowered.com/app/1318690/Shapezio/')
			},
			swiperClickCrafttheworld() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://www.wegame.com.cn/store/2000348/Craft_the_World')
			},
			swiperClickbloodrite() {
				//this.$router.push({path:'/newsDetail'})
				window.open('http://smzx.iwgame.com/')
			},
			swiperClickloong3d() {
				//this.$router.push({path:'/newsDetail'})
				window.open('http://loong.iwgame.com/')
			},
			swiperClickkungfuheros() {
				//this.$router.push({path:'/newsDetail'})
				window.open('http://gfyx.8yx.com/')
			},
			swiperClicknewmeteorandsword() {
				//this.$router.push({path:'/newsDetail'})
				window.open('http://xlx.8yx.com/Main/index.html')
			},
			swiperClicktod() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://store.steampowered.com/app/1361840/Tunnel_of_Doom/')
			},
			swiperClickiratus() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://store.steampowered.com/app/807120/Iratus_Lord_of_the_Dead/')
			},
			swiperClickreus() {
				//this.$router.push({path:'/newsDetail'})
				window.open('https://store.steampowered.com/app/222730/Reus/')
			},
			swiperClickcraftlands() {
				//this.$router.push({path:'/newsDetail'})
				window.open(
					'https://store.steampowered.com/app/1197820/Craftlands_Workshoppe__Third_Person_Resource_Management_and_Trading_RPG/'
				)
			},
			swiperClicktangledeep() {
				//this.$router.push({path:'/newsDetail'})
				window.open(
					'https://store.steampowered.com/app/628770/Tangledeep/'
				)
			}

		}
	}
</script>

<style scoped lang="scss">
	@import 'index';
</style>
